import {
  createFeatureSelector,
  createSelector,
  select,
  Store,
} from '@ngrx/store';
import { pipe, takeWhile } from 'rxjs';
import { filter } from 'rxjs/operators';
import { PLFetchAccounts } from '@common/store/actions';
import { Account } from '../models/account';
import { featureKey, PLAccountsState } from './state';

export const selectAccountState =
  createFeatureSelector<PLAccountsState>(featureKey);

export const selectAccountsState = createSelector(
  selectAccountState,
  (state: PLAccountsState) => state.accountsState
);

export const selectAccount = createSelector(
  selectAccountState,
  (state: PLAccountsState) => state.account
);

export const selectLoadedAccount = pipe(
  select(selectAccount),
  filter((account) => !!account)
);

export const selectAccountId = createSelector(
  selectAccount,
  (account: Account) => account?.uuid
);

export const selectAccountDeactivationDate = createSelector(
  selectAccount,
  (account: Account) => account?.deactivation_date
);

/// Fetches the user's account if not already fetched.
/// If an error occurs, the promise is rejected without any error.
export async function loadAccountByUuid(
  store: Store,
  accountUuid: string
): Promise<Account> {
  return new Promise((resolve, reject) => {
    store
      .select(selectAccountState)
      .pipe(
        takeWhile(({ account, accountsState }) => {
          const params = accountUuid ? { accountUuid } : {};
          switch (accountsState) {
            case 'init':
              store.dispatch(PLFetchAccounts({ ...params }));
              return true;
            case 'success':
              resolve(account);
              return false;
            case 'pending':
              return true;
            case 'error':
            default:
              reject(new Error('error loading account'));
              return false;
          }
        })
      )
      .subscribe();
  });
}

export async function loadAccount(store: Store): Promise<Account> {
  return loadAccountByUuid(store, null);
}
